import * as React from "react";

import { useMutationObserver } from "./useMutationObserver";

interface UseQuerySelectorOptions {
  enabled?: boolean;
  root?: Element;
}

export function useQuerySelector(
  selector: string,
  { enabled = true, root }: UseQuerySelectorOptions = {},
): Element | null {
  const [element, setElement] = React.useState<Element | null>(null);
  const observedRoot = (enabled && (root ?? document.body)) || null;

  React.useEffect(() => {
    setElement(observedRoot?.querySelector(selector) ?? null);
  }, [observedRoot, selector]);

  useMutationObserver({ target: observedRoot }, () => {
    if (!element) setElement(observedRoot?.querySelector(selector) ?? null);
  });

  return element;
}
